'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Contains passphrases for common networks:
 * * `Networks.PUBLIC`: `Public Global Stellar Network ; September 2015`
 * * `Networks.TESTNET`: `Test SDF Network ; September 2015`
 * @type {{PUBLIC: string, TESTNET: string}}
 */
var Networks = exports.Networks = {
  PUBLIC: 'LiveNet Global XDBChain Network ; November 2023',
  TESTNET: 'Futurenet XDBChain Network ; October 2023'
};


//////////////////
// WEBPACK FOOTER
// ./~/@xdbchain/js-stellar-base/lib/network.js
// module id = 546
// module chunks = 0